import React, { useState, useContext } from "react";
import { IconButton, Popover } from "@mui/material";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { Panel } from "./interfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tab, StyledTabs } from "./styles";
import { MultipleTabsContext } from "./MultipleTabs";
import { useTranslation } from "react-i18next";

interface Props {
  panels: Panel[];
  value: number;
  handleChangeValue: (value: number) => void;
  setRoutePath: (routePath: string | undefined) => void;
}
interface State {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
}
const MultipleTabsExtension = ({ panels, value, handleChangeValue, setRoutePath }: Props) => {
  const { t } = useTranslation();
  const { maxDisplayedTabs } = useContext(MultipleTabsContext);
  const [state, setState] = useState<State>({
    open: false,
    anchorEl: null,
  });
  return (
    <>
      <IconButton
        onClick={(event) => {
          setState((state) => ({
            ...state,
            open: true,
            anchorEl: event.currentTarget as HTMLButtonElement,
          }));
        }}
      >
        <FontAwesomeIcon icon={faEllipsisH} />
      </IconButton>
      <Popover
        open={state.open}
        anchorEl={state.anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={() => {
          setState((state) => ({ ...state, open: false }));
        }}
        PaperProps={{
          sx: {
            padding: "10px",
            //   backgroundColor: "rgb(245, 245, 245)",
          },
        }}
      >
        <StyledTabs
          value={value}
          onChange={(_, value) => handleChangeValue(value)}
          orientation={"vertical"}
          isExtension={true}
          maxDisplayedTabs={maxDisplayedTabs}
        >
          {panels.map(({ tabLabel, tabIcon, routePath, tabLabelRootPath }, idx) => (
            <Tab
              style={{ margin: 0, whiteSpace: "nowrap", justifyContent: "start" }}
              key={idx}
              label={tabLabelRootPath ? `${t(tabLabelRootPath)}` : tabLabel}
              iconPosition={"start"}
              disableRipple={true}
              onClick={() => setRoutePath(routePath)}
              title={tabLabel}
            />
          ))}
        </StyledTabs>
      </Popover>
    </>
  );
};
export default MultipleTabsExtension;
